<template>
  <div v-if="showTags" class="tags">
    <ul>
      <li
        v-for="(item, index) in tagsList"
        :key="index"
        class="tags-li"
        :class="{ active: isActive(item.path) }"
      >
        <router-link :to="item.path" class="tags-li-title">{{
          item.title
        }}</router-link>
        <span
          v-if="item.title !== '工作台'"
          class="tags-li-icon"
          @click="closeTags(index)"
        >
          <i class="el-icon-close"></i>
        </span>
      </li>
    </ul>
    <div class="tags-close-box">
      <el-dropdown @command="handleTags">
        <el-button size="mini" type="primary">
          标签选项
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown" size="small">
          <el-dropdown-item command="other">关闭其他</el-dropdown-item>
          <el-dropdown-item command="all">关闭所有</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import bus from './bus';

export default {
  // data() {
  //   return {
  //     tagsList: [],
  //   };
  // },
  computed: {
    tagsList() {
      return this.$store.state.tagsList;
    },
    showTags() {
      return this.tagsList.length > 0;
    },
    isPur() {
      const userInfo = this.$store.state.USERINFO || {};
      if (
        userInfo?.purchaseAreaFlag &&
        userInfo?.purchaseAreaCompanyId === userInfo?.companyId
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    $route(newValue, oldValue) {
      const isCloseTag =
        oldValue.path === '/productRelease' ||
        oldValue.path === '/productReleaseEdit' ||
        oldValue.path === '/openingCollection';
      const activeStep = Number(oldValue.query.activeStep) || null;
      if (isCloseTag) {
        for (let i = 0, len = this.tagsList.length; i < len; i++) {
          const item = this.tagsList[i];
          if (
            item != undefined &&
            (item.name === 'productRelease' ||
              item.name === 'productReleaseEdit' ||
              (item.name === 'openingCollection' && activeStep === 1))
          ) {
            this.closeTags(i);
          }
        }
      }
      if (newValue.name !== 'eaV3') {
        this.setTags(newValue);
      }
    },
  },
  created() {
    if (this.$route.name !== 'eaV3') {
      this.setTags(this.$route);
    }

    // 监听关闭当前页面的标签页
    bus.$on('close_current_tags', () => {
      this.$store.commit('closeCurrentTag', this);
    });
  },
  methods: {
    isActive(path) {
      return path === this.$route.fullPath;
    },
    // 关闭单个标签
    closeTags(index) {
      const delItem = this.tagsList[index];
      this.$store.commit('delTagsItem', {
        index,
      });
      const item = this.tagsList[index]
        ? this.tagsList[index]
        : this.tagsList[index - 1];
      if (item) {
        delItem.path === this.$route.fullPath && this.$router.push(item.path);
      } else {
        this.$router.push('/');
      }
    },
    // 关闭全部标签
    closeAll() {
      this.$store.commit('clearTags');
      this.$router.push('/');
    },
    // 关闭其他标签
    closeOther() {
      const curItem = this.tagsList.filter((item) => {
        return item.path === this.$route.fullPath || item.title === '工作台';
      });
      this.$store.commit('closeTagsOther', curItem);
    },

    // 设置标签
    setTags(route) {
      const isExist = this.tagsList.some((item) => {
        return item.path === route.fullPath;
      });
      if (
        this.tagsList.some((v) => {
          return v.fullPath === route.path;
        })
      ) {
        return;
      }
      if (!isExist) {
        if (this.tagsList.length >= 8) {
          this.$store.commit('delTagsItem', {
            index: 0,
          });
        }
        this.$store.commit('setTagsItem', {
          title:
            this.isPur && route.meta.title === '首页'
              ? '工作台'
              : route.meta.title,
          path: route.fullPath,
          fullPath: route.path,
          name: route.name,
        });
      }
      bus.$emit('tags', this.tagsList);
    },
    handleTags(command) {
      command === 'other' ? this.closeOther() : this.closeAll();
    },
  },
};
</script>

<style>
.tags {
  position: relative;
  height: 30px;
  overflow: hidden;
  background: #fff;
  padding-right: 120px;
  /*box-shadow: 0 5px 10px #ddd;*/
}

.tags ul {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

.tags-li {
  float: left;
  margin: 3px 5px 2px 3px;
  border-radius: 3px;
  font-size: 12px;
  overflow: hidden;
  cursor: pointer;
  height: 23px;
  line-height: 23px;
  border: 1px solid #e9eaec;
  background: #fff;
  padding: 0 5px 0 12px;
  vertical-align: middle;
  color: #666;
  -webkit-transition: all 0.3s ease-in;
  -moz-transition: all 0.3s ease-in;
  transition: all 0.3s ease-in;
}

.tags-li:not(.active):hover {
  background: #f8f8f8;
}

.tags-li.active {
  color: #fff;
}

.tags-li-title {
  float: left;
  max-width: 80px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 5px;
  color: #666;
}

.tags-li.active .tags-li-title {
  color: #fff;
}

.tags-close-box {
  position: absolute;
  right: 0;
  top: 0;
  box-sizing: border-box;
  padding-top: 1px;
  text-align: center;
  width: 110px;
  height: 30px;
  background: #fff;
  /*box-shadow: -3px 0 15px 3px rgba(0, 0, 0, .1);*/
  z-index: 10;
}
</style>
